// 1. Descobrir onde o React está a correr agora mesmo
const CURRENT_HOSTNAME = window.location.hostname;
const CURRENT_PROTOCOL = window.location.protocol; // HTTP ou HTTPS
const BASE_URL = `${CURRENT_PROTOCOL}//${CURRENT_HOSTNAME}`;

// 2. Verificar se estamos em modo de desenvolvimento local
// (Se estiver a correr o 'npm start' no teu próprio computador)
const isLocalhost = CURRENT_HOSTNAME === "localhost" || CURRENT_HOSTNAME === "127.0.0.1";

// 3. Definir as rotas com base no ambiente
let SOFTDATAWSURL;
let SOFTDATANODEJS;

if (isLocalhost) {
    // === MODO DESENVOLVIMENTO (Windows Local) ===
    
    // Se o teu Tomcat estiver a correr a app como ROOT.war:
    SOFTDATAWSURL = '/rest';    
    // NOTA: Se no Docker mantiveste o nome "softdata.war", então tens de usar:
    // SOFTDATAWSURL = '/softdata/rest';
    
    const njsPort = '8081';
    SOFTDATANODEJS = `http://127.0.0.1:${njsPort}`;
} else {
    // === MODO PRODUÇÃO / TESTE REDE (Passa pelo NGINX) ===
    SOFTDATAWSURL = `${BASE_URL}/legacy/rest`;
    SOFTDATANODEJS = `${BASE_URL}/api`;
}

// 4. Manter a compatibilidade com o teu código antigo
const HOSTNAME = CURRENT_HOSTNAME;
const NODEJSSERVER = CURRENT_HOSTNAME;
const DEBUG = isLocalhost; // Liga o debug automaticamente se estiveres em localhost

export { SOFTDATAWSURL };
export { SOFTDATANODEJS };
export { HOSTNAME };
export { NODEJSSERVER };
export { DEBUG };